import { render } from "./AddModel.vue?vue&type=template&id=15c8ff5b&ts=true"
import script from "./AddModel.vue?vue&type=script&lang=ts"
export * from "./AddModel.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-distribution-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__